import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { SearchResult, SearchType } from '../../models/SearchResult';
import { Subject, EMPTY } from 'rxjs';
import { switchMap, filter, debounceTime, distinctUntilChanged, map, catchError } from 'rxjs/operators';
import { SRResponse } from '../../models/SRResponse';
import { AppSettings } from '../../common/config';

const API_ENDPOINT = AppSettings.API_SERVER + '/smart-response/search';

@Component({
  selector: 'search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
})
export class SearchComponent implements OnInit {
  searchEnum = SearchType;

  public selectedItem!: SearchResult;

  public url = [];

  allChecked = true;
  locationChecked = false;
  organizationChecked = false;
  disasterChecked = false;

  searchInput$ = new Subject<string>();
  ngSelectData: any[] = [];
  isLoading = false;
  ngSelectSearchStr: string | null = null;
  currentSearchTerm = '';
  dropdownOpen = false;

  // Store raw results from API
  rawResults: any[] = [];

  public searchType = SearchType.All;

  constructor(private router: Router, private http: HttpClient) { }

  ngOnInit() {

    // Add ng-select pipe alongside
    this.searchInput$.pipe(
      filter(term => !!term && term.length >= 3),
      debounceTime(700),
      distinctUntilChanged(),
      switchMap(term => {
        this.isLoading = true;
        return this.http.get<SRResponse>(API_ENDPOINT, {
          params: { search: term }
        }).pipe(
          map(res => res.responseData.search_result_list),
          catchError(() => EMPTY)
        );
      })
    ).subscribe((rawList: any) => {
      this.isLoading = false;
      this.rawResults = rawList;
      this.applyFilter(); // Filter and map seperately
    });
  }

  private applyFilter(): void {
    this.ngSelectData = this.rawResults
      .filter(item => {
        const type: string = item.searchResultType;
        return SearchType[type] & this.searchType;
      })
      .map(item => this.convertToItem(item))
  }

  public convertToItem(data: any): any | null {
    if (!data) {
      return null;
    }

    return {
      image: 'assets/images/search-icon.png',
      title: data.searchResultName,
      description: data.searchResultType,
      originalObject: data,
    };
  }

  onNgSelectItem(item: any) {
    this.url = [];
    if (item) {
      this.selectedItem = <SearchResult>item.originalObject;
      const type: string = this.selectedItem.searchResultType.toLowerCase();
      this.url.push(`/${type}`);
      this.url.push(this.selectedItem.disasterLocationOrganizationId);
      this.router.navigate(this.url);
    }
  }

  public onSelectedItem(selected: any) {
    this.url = [];
    if (selected) {
      this.selectedItem = <SearchResult>selected.originalObject;
      const type: string = this.selectedItem.searchResultType.toLowerCase();
      this.url.push(`/${type}`);
      this.url.push(this.selectedItem.disasterLocationOrganizationId);
      this.router.navigate(this.url);
    }
  }

  onSearchInput(event: { term: string; items: any[] }): void {
    this.currentSearchTerm = event.term;

  }

  onDropdownClose(): void {
    if (!this.ngSelectSearchStr) {
      this.onClear();
    }
  }

  public toggleEnum(checked: boolean, type: SearchType) {
    if (this.allChecked) {
      this.allChecked = !this.allChecked;
      this.searchType &= ~this.searchEnum.All;
    }

    checked ? (this.searchType |= type) : (this.searchType &= ~type);

    if (!this.disasterChecked && !this.locationChecked && !this.organizationChecked) {
      this.allChecked = true;
      this.searchType = this.searchEnum.All;
    }
  }

  toggleAll($event: any) {
    if (!$event.target.checked) {
      $event.preventDefault();
    }

    this.locationChecked = this.disasterChecked = this.organizationChecked = false;
    this.searchType = this.searchEnum.All;
    this.applyFilter();
  }

  onClear() {
    this.currentSearchTerm = '';
    this.ngSelectSearchStr = null;
    this.ngSelectData = [];
  }

}
